import { render, staticRenderFns } from "./PaymentFailed.vue?vue&type=template&id=14484c13&"
import script from "./PaymentFailed.vue?vue&type=script&lang=js&"
export * from "./PaymentFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports